import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { getCustomerNumber2, resetCustomerNumber2 } from '../../../service/actions/secreteryAction'
import './style.scss'
import { CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem } from '@coreui/react'
import { enToPersianChar } from '../../../components/helper'


const NumberPage = ({
    WaitingCustomerNumber2,
    SuccessCustomerNumber2,
    ErrorCustomerNumber2,
    Customer
}) => {

    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [numberList, setNumberList] = useState([])
    //********************************************************************************************************* */
    useEffect(() => {
        dispatch(getCustomerNumber2());
        return () => {
            resetCustomerNumber2();
        }
    }, [])
    //********************************************************************************************************** */
    useEffect(() => {
        if (SuccessCustomerNumber2) {
            setNumberList(Customer);
        }
        if (ErrorCustomerNumber2 !== '') {

        }
    }, [SuccessCustomerNumber2, ErrorCustomerNumber2,])

    //********************************************************************************************************* */
    const secreteryInstruction = (index) => {
        navigate('/secreteryPage', { state: { CustomerLineId: index.CustomerLineId, title: index.Title, number: index.Number } })

    }
    //********************************************************************************************************** */

    return (
        <div>
            <CAccordion activeItemKey={1}>
                <CAccordionItem itemKey={1}>
                    <CAccordionHeader>شماره های فعال</CAccordionHeader>
                    <CAccordionBody>
                        {Customer.map((number, index) =>
                            <div className='number-item' key={index}>
                                {number.ServiceType === 1 &&
                                    <div className='d-flex justify-content-between'>
                                        <div>{number.Title ? number.Title : number.Number}</div>
                                        <div>
                                            <Link to={`/secretaryPage/${number.CustomerLineId}`} state={{ title: number.Title, number: number.Number }} >
                                                <span>دستورالعمل منشی</span>
                                            </Link>
                                        </div>

                                    </div>}
                                {number.ServiceType === 2 &&
                                    <div className='d-flex justify-content-between'>
                                        <div>{number.Title ? number.Title : enToPersianChar(number.Number)}</div>
                                        <div>
                                            <Link to={`/ivrSetting/${number.CustomerLineId}`}>
                                                <span>تنظیمات تلفن گویا</span>
                                            </Link>
                                        </div>

                                    </div>}




                                {/* <p className='number-title col-lg-2'>{number.Title !== '' ? number.Title : '---'}</p>
                                <button onClick={() => { secreteryInstruction(index) }} className='col-lg-2'>دستورالعمل منشی</button>
                                <br />
                                <hr /> */}
                            </div>


                        )}
                    </CAccordionBody>
                </CAccordionItem>

            </CAccordion>
        </div>

    )
}

NumberPage.propTypes = {
    WaitingCustomerNumber2: PropTypes.bool,
    SuccessCustomerNumber2: PropTypes.bool,
    ErrorCustomerNumber2: PropTypes.string,
    Customer: PropTypes.array,
}
//*************************************************************************************************** */

const mapStateToProps = (state) => ({
    WaitingCustomerNumber2: state.secreteryReducer.WaitingCustomerNumber2,
    SuccessCustomerNumber2: state.secreteryReducer.SuccessCustomerNumber2,
    ErrorCustomerNumber2: state.secreteryReducer.ErrorCustomerNumber2,
    Customer: state.secreteryReducer.Customer,
})
export default connect(mapStateToProps)(NumberPage)